<div class="badge" [ngClass]="{ 'badge-not-trained': !hasTrained }">
  <ion-icon [src]="soccerCoinUrl"></ion-icon>
  <div>
    {{ streak }}
  </div>
</div>
